<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">PARTNER</a>
      </label>
    </div>

    <div class="button-wrapper" *ngIf="groups.includes('admin') || groups.includes('operation')">
      <button class="btn btn-white vertical full-width-btn align-items-center" routerLink="/partner/nuovo">
        Aggiungi Partner<i class="ml-30 fas fa-plus"></i>
      </button>
    </div>

    <section class="main-content wrapper content-padding scroll-delivery">
      <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
      <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">

        <form class="table-row-container row first-row filter" [formGroup]="_partnerFilterForm" (ngSubmit)="filter()" *ngIf="_partnerFilterForm">

          <div class="item data-col-5">
            <h4 class="title" (click)="navigateOrder('Partner.id')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Partner.id')"></i>
              ID
            </h4>
            <span class="data">
              <input type="text" formControlName="Partner.id">
            </span>
          </div>

          <div class="item data-col-15">
            <h4 class="title" (click)="navigateOrder('Partner.businessName')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
              Ragione sociale
            </h4>
            <span class="data">
              <input type="text" formControlName="Partner.businessName">
            </span>
          </div>

          <div class="item data-col-15 center">
            <h4 class="title" (click)="navigateOrder('User.email')">
              <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
              Email
            </h4>
            <span class="data">
              <input type="text" formControlName="User.email">
            </span>
          </div>

          <div class="item data-col-10 center">
            <h4 class="title" (click)="navigateOrder('Partner.phone')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Partner.phone')"></i>
              Telefono
            </h4>
            <span class="data">
              <input type="text" formControlName="Partner.phone">
            </span>
          </div>

          <div class="item data-col-15 center">
            <h4 class="title" (click)="navigateOrder('Partner.city')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Partner.city')"></i>
              Città
            </h4>
            <span class="data">
              <input type="text" formControlName="Partner.city">
            </span>
          </div>

          <div class="item data-col-20">
            <h4 class="title" (click)="navigateOrder('Partner.address')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Partner.address')"></i>
              Indirizzo
            </h4>
            <span class="data">
              <input type="text" formControlName="Partner.address">
            </span>
          </div>

          <div class="item data-col-10 center partner-sold-category-column">
            <h4 class="title" (click)="navigateOrder('ProductCategory.categoryName')">
              <i class="sort-icon fas" [ngClass]="orderIcon('ProductCategory.categoryName')"></i>
              Partner's Catalog
            </h4>
            <span class="data">
              <input type="text" formControlName="ProductCategory.categoryName">
            </span>
          </div>

          <div class="item data-col-15 center">
            <h4 class="title" (click)="navigateOrder('Partner.partnerPaymentMethod')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Partner.partnerPaymentMethod')"></i>
              Payment Method</h4>
            <span class="data">
              <select formControlName="Partner.partnerPaymentMethod">
                <option value="">Tutti</option>
                <option value="bankTransfer">Bank Transfer</option>
                <option value="creditCard">Credit Card</option>
                <option value="directDebitMandate">Direct Debit</option>
              </select>
            </span>
          </div>

          <div class="item data-col-15 center">
            <h4 class="title" (click)="navigateOrder('Partner.partnerPaymentStatus')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Partner.partnerPaymentStatus')"></i>
              Payment Status</h4>
            <span class="data">
              <select formControlName="Partner.partnerPaymentStatus">
                <option value="">Tutti</option>
                <option value="active">Attivo</option>
                <option value="inactive">Inactive</option>
                <option value="blocked">Blocked</option>
              </select>
            </span>
          </div>

          <div class="item data-col-15 center">
            <h4 class="title" (click)="navigateOrder('User.active')">
              <i class="sort-icon fas" [ngClass]="orderIcon('User.active')"></i>
              Attivo</h4>
            <span class="data">
              <select formControlName="User.active">
                <option value="">Tutti</option>
                <option value="1">Attivo</option>
                <option value="-1">Disattivo</option>
              </select>
            </span>
          </div>

          <div class="item nowrap">
            <h4 class="title hide-on-mobile">AZIONI</h4>
            <span class="data-row-left btn-container btn-container-actions">
              <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                RICERCA <i class="fas fa-search"></i></button>
                <br/>
              <button class="btn vertical align-items-center" (click)="resetFilter();">
                RESET <i class="fas fa-times-circle"></i></button>
            </span>
          </div>
        </form>

        <div class="table-row-container row" *ngFor="let partner of partners">

          <div class="item data-col-5">
            <h4 class="title" (click)="navigateOrder('Partner.id')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Partner.id')"></i>
              ID
            </h4>
            <span class="data data-id"><a [routerLink]="['/partner', partner.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader')) || (groups.includes('expert') && loggedInExpert?.isTeamLeader) }">{{partner.id}}</a></span>
          </div>

          <div class="item data-col-15">
            <h4 class="title" (click)="navigateOrder('Partner.businessName')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
              Ragione sociale
            </h4>
            <span class="data"><a [routerLink]="['/partner', partner.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader) )}">{{partner.businessName}}</a></span>
          </div>

          <div class="item data-col-15 center">
            <h4 class="title" (click)="navigateOrder('User.email')">
              <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
              Email
            </h4>
            <span class="data"><a [routerLink]="['/partner', partner.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader) )}">{{partner.user.email}}</a></span>
          </div>

          <div class="item data-col-10 center">
            <h4 class="title" (click)="navigateOrder('Partner.phone')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Partner.phone')"></i>
              Telefono
            </h4>
            <span class="data"><a [routerLink]="['/partner', partner.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader) )}">{{partner.phone}}</a></span>
          </div>

          <div class="item data-col-15 center">
            <h4 class="title" (click)="navigateOrder('Partner.city')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Partner.city')"></i>
              Città
            </h4>
            <span class="data"><a [routerLink]="['/partner', partner.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader) )}">{{partner.city}}</a></span>
          </div>

          <div class="item data-col-20">
            <h4 class="title" (click)="navigateOrder('Partner.address')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Partner.address')"></i>
              Indirizzo
            </h4>
            <span class="data"><a [routerLink]="['/partner', partner.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader) )}">{{partner.address}}</a></span>
          </div>

          <div class="item data-col-10 center partner-sold-category-column">
            <h4 class="title">Partner's Catalog</h4>
            <div *ngIf="partner?.partnerSoldProductCategories?.length > 0">
              <a [routerLink]="['/partner', partner.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader) )}">
                <span *ngFor="let data of partner?.partnerSoldProductCategories; let last = last">{{ data?.productCategory?.categoryName }}
                  <ng-container *ngIf="!last">, </ng-container>
                </span>
              </a>
            </div>
            <div *ngIf="partner?.partnerSoldProductCategories?.length === 0"> 
              N/A
            </div>
          </div>

          <div class="item data-col-15 center">
            <h4 class="title"><i class="sort-icon fas"></i>Payment Method</h4>
            <span class="data">
              {{ partner?.partnerPaymentMethod?.toUpperCase() || "N/A" }}
            </span>
          </div>

          <div class="item data-col-15 center">
            <h4 class="title"><i class="sort-icon fas"></i>Payment Status</h4>
            <span class="data">
              {{ partner?.partnerPaymentStatus?.toUpperCase() || "N/A" }}
            </span>
          </div>

          <div class="item data-col-15 center">
            <h4 class="title"><i class="sort-icon fas"></i>Attivo</h4>
            <span class="data">
              {{translateActive(partner.user.active)}}
            </span>
          </div>

          <div class="item nowrap">
            <span class="data-row-left btn-container btn-container-actions">
              <button class="btn vertical align-items-center" [routerLink]="['/partner', partner.id, 'availability']" *ngIf="!groups.includes('teamleader')">
                Vecchia Disponibilità
              </button>
              <button class="btn vertical align-items-center" [routerLink]="['/partner', 'availability', partner.id]" *ngIf="!groups.includes('teamleader')">
                Disponibilità
              </button>
              <button class="btn vertical align-items-center" [routerLink]="['/partner', partner.id, 'edit']" *ngIf="groups.includes('admin') || groups.includes('operation')">
                Modifica
              </button>
              <button class="btn btn-red vertical align-items-center" (click)="$event.preventDefault(); delete(partner.id)" *ngIf="groups.includes('admin')">
                Elimina<i class="ml-10 far fa-trash-alt"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
    </section>
  </div>
</section>

<!--
<section class="title-bar content-padding first-item">
  <div class="wrapper nowrap">
    <h2 class="title-heading">Partner</h2>
    <div class="item nowrap" *ngIf="groups.includes('admin') || groups.includes('operation')">
      <span class="data-row-left btn-container top-button-container">
        <button class="btn btn-white vertical full-width-btn align-items-center" routerLink="/partner/nuovo">
          Aggiungi Partner<i class="ml-30 fas fa-plus"></i>
        </button>
      </span>
    </div>
  </div>
</section>

<section class="main-content wrapper content-padding scroll-delivery">
  <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)">
  </app-pagination>
  <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
    <form class="table-row-container row first-row filter" [formGroup]="_partnerFilterForm" (ngSubmit)="filter()"
      *ngIf="_partnerFilterForm">
      <div class="item data-col-5">
        <h4 class="title" (click)="navigateOrder('Partner.id')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Partner.id')"></i>
          ID</h4>
        <span class="data">
          <input type="text" formControlName="Partner.id">
        </span>
      </div>
      <div class="item data-col-15">
        <h4 class="title" (click)="navigateOrder('Partner.businessName')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
          Ragione sociale</h4>
        <span class="data">
          <input type="text" formControlName="Partner.businessName">
        </span>
      </div>
      <div class="item data-col-15 center">
        <h4 class="title" (click)="navigateOrder('User.email')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
          Email</h4>
        <span class="data">
          <input type="text" formControlName="User.email">
        </span>
      </div>
      <div class="item data-col-10 center">
        <h4 class="title" (click)="navigateOrder('Partner.phone')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Partner.phone')"></i>
          Telefono</h4>
        <span class="data">
          <input type="text" formControlName="Partner.phone">
        </span>
      </div>
      <div class="item data-col-15 center">
        <h4 class="title" (click)="navigateOrder('Partner.city')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Partner.city')"></i>
          Città</h4>
        <span class="data">
          <input type="text" formControlName="Partner.city">
        </span>
      </div>
      <div class="item data-col-20">
        <h4 class="title" (click)="navigateOrder('Partner.address')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Partner.address')"></i>
          Indirizzo</h4>
        <span class="data">
          <input type="text" formControlName="Partner.address">
        </span>
      </div>

      <div class="item data-col-10 center partner-sold-category-column">
        <h4 class="title" (click)="navigateOrder('ProductCategory.categoryName')">
          <i class="sort-icon fas" [ngClass]="orderIcon('ProductCategory.categoryName')"></i>
          Partner's Catalog
        </h4>
        <span class="data">
          <input type="text" formControlName="ProductCategory.categoryName">
        </span>
      </div>

      <div class="item data-col-15 center">
        <h4 class="title" (click)="navigateOrder('Partner.partnerPaymentMethod')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Partner.partnerPaymentMethod')"></i>
          Payment Method</h4>
        <span class="data">
          <select formControlName="Partner.partnerPaymentMethod">
            <option value="">Tutti</option>
            <option value="bankTransfer">Bank Transfer</option>
            <option value="creditCard">Credit Card</option>
            <option value="directDebitMandate">Direct Debit</option>
          </select>
        </span>
      </div>

      <div class="item data-col-15 center">
        <h4 class="title" (click)="navigateOrder('Partner.partnerPaymentStatus')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Partner.partnerPaymentStatus')"></i>
          Payment Status</h4>
        <span class="data">
          <select formControlName="Partner.partnerPaymentStatus">
            <option value="">Tutti</option>
            <option value="active">Attivo</option>
            <option value="inactive">Inactive</option>
            <option value="blocked">Blocked</option>
          </select>
        </span>
      </div>

      <div class="item data-col-15 center">
        <h4 class="title" (click)="navigateOrder('User.active')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.active')"></i>
          Attivo</h4>
        <span class="data">
          <select formControlName="User.active">
            <option value="">Tutti</option>
            <option value="1">Attivo</option>
            <option value="-1">Disattivo</option>
          </select>
        </span>
      </div>

      <div class="item nowrap">
        <h4 class="title hide-on-mobile">AZIONI</h4>
        <span class="data-row-left btn-container btn-container-actions">
          <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
            RICERCA <i class="fas fa-search"></i></button>
            <br/>
          <button class="btn vertical align-items-center" (click)="resetFilter();">
            RESET <i class="fas fa-times-circle"></i></button>
        </span>
      </div>
    </form>
    <div class="table-row-container row" *ngFor="let partner of partners">
      <div class="item data-col-5">
        <h4 class="title" (click)="navigateOrder('Partner.id')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Partner.id')"></i>
          ID</h4>
        <span class="data data-id"><a [routerLink]="['/partner', partner.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader')) || (groups.includes('expert') && loggedInExpert?.isTeamLeader) }">{{partner.id}}</a></span>
      </div>
      <div class="item data-col-15">
        <h4 class="title" (click)="navigateOrder('Partner.businessName')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
          Ragione sociale</h4>
        <span class="data"><a [routerLink]="['/partner', partner.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader) )}">{{partner.businessName}}</a></span>
      </div>
      <div class="item data-col-15 center">
        <h4 class="title" (click)="navigateOrder('User.email')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
          Email</h4>
        <span class="data"><a [routerLink]="['/partner', partner.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader) )}">{{partner.user.email}}</a></span>
      </div>
      <div class="item data-col-10 center">
        <h4 class="title" (click)="navigateOrder('Partner.phone')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Partner.phone')"></i>
          Telefono</h4>
        <span class="data"><a [routerLink]="['/partner', partner.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader) )}">{{partner.phone}}</a></span>
      </div>
      <div class="item data-col-15 center">
        <h4 class="title" (click)="navigateOrder('Partner.city')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Partner.city')"></i>
          Città</h4>
        <span class="data"><a [routerLink]="['/partner', partner.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader) )}">{{partner.city}}</a></span>
      </div>
      <div class="item data-col-20">
        <h4 class="title" (click)="navigateOrder('Partner.address')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Partner.address')"></i>
          Indirizzo</h4>
        <span class="data"><a [routerLink]="['/partner', partner.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader) )}">{{partner.address}}</a></span>
      </div>

      <div class="item data-col-10 center partner-sold-category-column">
        <h4 class="title">Partner's Catalog</h4>
        <div *ngIf="partner?.partnerSoldProductCategories?.length > 0">
          <a [routerLink]="['/partner', partner.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader) )}">
            <span *ngFor="let data of partner?.partnerSoldProductCategories; let last = last">{{ data?.productCategory?.categoryName }}
              <ng-container *ngIf="!last">, </ng-container>
            </span>
          </a>
        </div>
        <div *ngIf="partner?.partnerSoldProductCategories?.length === 0"> 
          N/A
        </div>
      </div>

      <div class="item data-col-15 center">
        <h4 class="title"><i class="sort-icon fas"></i>Payment Method</h4>
        <span class="data">
          {{ partner?.partnerPaymentMethod?.toUpperCase() || "N/A" }}
        </span>
      </div>

      <div class="item data-col-15 center">
        <h4 class="title"><i class="sort-icon fas"></i>Payment Status</h4>
        <span class="data">
          {{ partner?.partnerPaymentStatus?.toUpperCase() || "N/A" }}
        </span>
      </div>

      <div class="item data-col-15 center">
        <h4 class="title"><i class="sort-icon fas"></i>Attivo</h4>
        <span class="data">
          {{translateActive(partner.user.active)}}
        </span>
      </div>

      <div class="item nowrap">
        <span class="data-row-left btn-container btn-container-actions">

          <button class="btn vertical align-items-center" [routerLink]="['/partner', partner.id, 'availability']" *ngIf="!groups.includes('teamleader')">
            Disponibilità
          </button>
          <button class="btn vertical align-items-center" [routerLink]="['/partner', partner.id, 'edit']" *ngIf="groups.includes('admin') || groups.includes('operation')">
            Modifica
          </button>
          <button class="btn btn-red vertical align-items-center" (click)="$event.preventDefault(); delete(partner.id)" *ngIf="groups.includes('admin')">
            Elimina<i class="ml-10 far fa-trash-alt"></i>
          </button>
        </span>
      </div>
    </div>
  </div>
</section>
-->
